<template>
  <div id="FeedbackModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <img
            :src="require(`../../assets/images/feedback-modal@2x.png`)"
            :srcset="`${require(`../../assets/images/feedback-modal@1x.png`)} 1x, ${require(`../../assets/images/feedback-modal@2x.png`)} 2x, ${require(`../../assets/images/feedback-modal@3x.png`)} 3x, ${require(`../../assets/images/feedback-modal@4x.png`)} 4x`"
        />
        <feedback-form-modal v-if="!feedbackManager?.submitted"></feedback-form-modal>
        <feedback-sent-modal v-if="feedbackManager?.submitted"></feedback-sent-modal>
      </div>
    </div>
  </div>
</template>
<script>
import {EventBus} from '../../events/event.bus';
import {OPEN_FEEDBACK_MODAL} from '../../events/app.events';
import FeedbackManager from "../../manager/FeedbackManager";
import FeedbackFormModal from "./Content/FeedbackFormModal.vue";
import FeedbackSentModal from "./Content/FeedbackSentModal.vue";
import Analytics from "../../util/Analytics";
import currentJob from './../../mixins/current_job.mixin';
import store from "../../mixins/store.mixin";

export default {
  name: 'FeedbackModal',
  props: {},
  components: {FeedbackFormModal, FeedbackSentModal},
  mixins: [store, currentJob],
  data() {
    return {
      feedbackManager: FeedbackManager
    };
  },
  mounted: function () {
    $('#FeedbackModal').modal({show: false});
  },
  created: function () {
    EventBus.$on(OPEN_FEEDBACK_MODAL, (data) => {
      Analytics.send('creator_studio_modal', `modal_feedback`, this.currentJob);

      this.feedbackManager.setSubmit(false);
      $('#FeedbackModal').modal('show');
    });
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss">
#FeedbackModal {
  img {
    width: 100%;
    border-radius: 0.3rem 0.3rem 0 0;
  }

  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .feedback-submit-btn {
    background-color: #1266F1;
    color: #E8EAED;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .feedback-text-area {
    padding-bottom: 3px;
    background: #fff;
    color: #2e2e2e;
    position: relative;
    border-radius: 5px;
    border: 1px solid #CBCBCB;

    textarea {
      font-size: 18px !important;
      margin: 40px 20px 0 20px !important;
      padding: 0;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
